//#region Libraries
import {
    useState, 
    useEffect
} from "react";
//#endregion
//#region Styles
import {
    Container, 
    Title } from "../../../styles";
import {
    Content, 
    FieldsGroup } from "./styles";    
//#endregion
//#region Components
import CustomSelect from "components/CustomSelect/CustomSelect";
import CustomTextInput from "components/CustomTextInput/CustomTextInput";
import OrDivider from "components/OrDivider/OrDivider";
import ErrorMessage from "components/ErrorMessage/ErrorMessage";
//#endregion
//#region Utils
import { handlerKeyPressOnlyNumbersAndLetters } from "utils/validations";
//#endregion

const LocationPlaceStep2 = ({
    campusId,
    campusEnvironments, 
    form, errors, 
    changeField, as
}) => {
    const { inCampus, outCampus } = form;
    //#region States
    const [filteredCampusEnvironments, setFilteredCampusEnvironments] = useState([]);
    //#endregion
    useEffect(() => {
        fillFilteredCampusEnvironments();
    }, [campusId]);
    useEffect(() => {
        const { internalOrExternal, address } = outCampus;
        if (internalOrExternal || address) 
            resetInCampus();
    }, [outCampus]);
    useEffect(() => {
        if (inCampus.id) 
            resetOutCampus();
    }, [inCampus]);
    //#region Functions
    const resetInCampus = () => {
        changeField("inCampus", {
            id: 0,
            address: "",
            floor: ""
        }, {
            envId: false,
            floor: false
        });
    }
    const resetOutCampus = () => {
        changeField("outCampus", {
            internalOrExternal: "",
            address: ""
        }, {
            internalOrExternal: false,
            address: false
        });
    }
    const changeInCampus = id => {
        const address = filteredCampusEnvironments.find(item => {
            return item.id === id;
        })?.address || "";
        changeField("inCampus", {
            ...form.inCampus,
            id,
            address
        }, {
            ...errors.inCampus,
            envId: false
        });
    }
    const changeOutCampusInternalOrExternalEnvironment = internalOrExternal => {
        changeField("outCampus", {
            ...outCampus,
            internalOrExternal
        }, {
            ...errors.outCampus,
            internalOrExternal: false
        });
    }
    const changeOutCampusAddressEnvironment = address => {
        changeField("outCampus", {
            ...outCampus,
            address
        }, {
            ...errors.outCampus,
            address: false
        });
    }
    const changeInCampusFloor = floor => {
        changeField("inCampus", {
            ...form.inCampus,
            floor
        }, {
            ...errors.inCampus,
            floor: false
        });
    }
    const fillFilteredCampusEnvironments = () => {
        const filteredEnvironments = campusEnvironments.filter(item => {
            return campusId === item.campusId;
        });
        setFilteredCampusEnvironments(filteredEnvironments);
    }
    //#endregion
    const anyCompleted = (
        errors.inCampus.envId && 
        errors.inCampus.floor &&
        errors.outCampus.internalOrExternal && 
        errors.outCampus.address
    );
    return (
        <Container>
            <Title>Paso 02:</Title>
            <Content>
                <section>
                    <h4>Dentro del Campus UTP</h4>
                    <FieldsGroup>
                        <CustomSelect
                            label="Escoge un ambiente dentro del Campus"
                            value={inCampus.id}
                            onChange={changeInCampus}
                            defaultOptionText="Selecciona un ambiente"
                            disabled={campusId <= 0 || 
                                outCampus.internalOrExternal || 
                                outCampus.address}
                            width={{
                                container: "100%",
                                containerSelect: "100%"
                            }}
                            optionsProps={filteredCampusEnvironments.map(
                                ({ id, name : _name }) => {
                                    return {
                                        value: id,
                                        text: _name 
                                    };
                                })}
                            error={errors.inCampus.envId}
                            errorText={!anyCompleted && `Selecciona el ambiente para el ${as}`}/>
                        <CustomTextInput
                            label="Dirección"
                            value={inCampus.address}
                            disabled
                            placeholder="Dirección del ambiente"
                            error={errors.inCampus.envId}/>
                        <CustomTextInput
                            label="Piso"
                            value={inCampus.floor}
                            onChange={changeInCampusFloor}
                            onKeyPress={handlerKeyPressOnlyNumbersAndLetters}
                            maxLength={100}
                            placeholder="Agregar piso"
                            disabled={outCampus.internalOrExternal || outCampus.address}
                            error={errors.inCampus.floor}
                            errorText={!anyCompleted && `Escribe el piso para el ${as}`}/>
                    </FieldsGroup>
                </section>
                <OrDivider/>
                <section>
                    <h4>Fuera del Campus UTP</h4>
                    <FieldsGroup>
                        <CustomTextInput
                            label="Ambiente interno o externo "
                            value={outCampus.internalOrExternal}
                            onChange={changeOutCampusInternalOrExternalEnvironment}
                            placeholder="Ejemplo: Cancha 1 Innova School"
                            maxLength={250}
                            error={errors.outCampus.internalOrExternal}
                            errorText={(
                                anyCompleted || inCampus.id > 0
                            ) ? null : `Escribe el ambiente para el ${as}`}/>
                        <CustomTextInput
                            label="Dirección"
                            maxLength={250}
                            value={outCampus.address}
                            onChange={changeOutCampusAddressEnvironment}
                            placeholder="Ejemplo: Avenida Perú 123, Los Olivos"
                            error={errors.outCampus.address}
                            errorText={(
                                    anyCompleted || inCampus.id > 0
                                ) ? null : `Escribe la dirección para el ${as}`}/>
                    </FieldsGroup>
                </section>
            </Content>
            <ErrorMessage 
                error={anyCompleted}
                text={`Escoge o escribe el ambiente y dirección donde será el ${as} (Dentro o Fuera de UTP).`}/>
        </Container>
    );
}

export default LocationPlaceStep2;